import {SHARE_DEFAULT} from './settings/constants';
import {Component, createRef} from 'preact';

const BLOCK_ACTIVE = 'share__wrapper_active';

export default class ShareComponent extends Component {
  constructor(props) {
    super(props);

    this.onShareClick = this.onShareClick.bind(this);
  }

  share = createRef();
  onShareClick = function () {
    this.share.current.classList.toggle(BLOCK_ACTIVE);
  };

  get classNames() {
    if (this._classNames) {
      return this._classNames;
    }
    this._classNames = (this.props.classNames) ? this.props.classNames : {mainWrapper: 'share__list', listItem: '', linkItem: 'share__social-link'};
    return this._classNames;
  }

  get parameters() {
    if (this._parameters) {
      return this._parameters;
    }
    if (this.props.parameters) {
      this._parameters = this.props.parameters;
      return this._parameters;
    }

    return {
      url: 'https://www.mk.ru/projects/nacputevoditeli/education-game/',
      messangerText: 'https://www.mk.ru/projects/nacputevoditeli/education-game/',
      title: 'Мой НАЦПРОЕКТ «ОБРАЗОВАНИЕ»'
    };
  }

  get settings() {
    if (this._settings) {
      return this._settings;
    }
    this._settings = new Map((this.props.settings) ? this.props.settings : SHARE_DEFAULT);
    return this._settings;
  }

  getUrl(itemSettings) {
    if (!itemSettings.api) {
      return null;
    }
    let isFirstKey = true;
    let url = itemSettings.api;
    if ('additionalKey' in itemSettings) {
      url += (isFirstKey) ? '?' : '&';
      url += itemSettings.additionalKey;
      isFirstKey = false;
    }
    Object.keys(itemSettings.keys).forEach((key) => {
      if (key in this.parameters) {
        url += (isFirstKey) ? '?' : '&';
        isFirstKey = false;
        url += ((key === 'title') && !('url' in itemSettings.keys)) ? `${itemSettings.keys[key]}=${encodeURIComponent(this.parameters[key] + ' ' + this.parameters['url'])}` : `${itemSettings.keys[key]}=${encodeURIComponent(this.parameters[key])}`;
      }
    });
    return url;
  }

  renderItem(itemSettings) {
    if (!itemSettings) {
      return null;
    }
    const icon = (itemSettings.mod) ? <span dangerouslySetInnerHTML={{__html: `<svg width="22" height="22"><use xlink:href="#svg-icon-${itemSettings.mod}"></use></svg>` }} /> : null;
    let listItemClass = `${(this.classNames.listItem) ? this.classNames.listItem : ''}`;
    linkItemClass += `${(this.classNames.listItem && itemSettings.mod) ? this.classNames.listItem + '_' + itemSettings.mod : ''}`;
    let linkItemClass = `${(this.classNames.linkItem) ? this.classNames.linkItem : ''}`;
    linkItemClass += `${(this.classNames.linkItem && itemSettings.mod) ? ' ' + this.classNames.linkItem + '_' + itemSettings.mod : ''}`;
    return <li className={(listItemClass) ? listItemClass : null}>
    <a className={(linkItemClass) ? linkItemClass : null} onClick={(evt) => {
      evt.preventDefault();
      window.open(this.getUrl(itemSettings),'','toolbar=0,status=0,width=626,height=436');
      (this.props.classNames) ? ('ga' in window) && ga('send', 'event', 'education-project', 'education_share-final-screen', (itemSettings.title) ? itemSettings.title : '') :  ('ga' in window) && ga('send', 'event', 'education-game-project', 'education-game_share-header', (itemSettings.title) ? itemSettings.title : '');
    }} href={this.getUrl(itemSettings)} target={"_blank"} rel={"nofollow noopener"} title={(itemSettings.title) ? itemSettings.title : null}>
      {icon}
    </a></li>
    ;
  }

  render() {
    const listButtons = Array.from(this.settings, ([key, value]) => value).map((item) => this.renderItem(item));

    return (
      <div ref={this.share} className="share__wrapper">
        <div className="share__overlay"></div>

        <div className="share__body">
          <span className="share__title">Поделиться</span>

          <ul className={(this.classNames.mainWrapper) ? this.classNames.mainWrapper : null}>
            {listButtons}
          </ul>
        </div>

        <button onClick={this.onShareClick} className="share__button" aria-label="Поделиться">
          <svg className="share__button-icon" width="44" height="44">
            <use xlinkHref="#svg-share"></use>
          </svg>
        </button>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./components/share/index.js